export default __webpack_public_path__ + "static/media/ttr_Presentation.eec879da.pdf";